import { Form } from 'antd';
import { cloneElement } from 'react';

export function InputSelect({
  name = '',
  label = '',
  tooltip = '',
  required = false,
  children = <></>,
  disabled = false,
  placeholder = '',
}) {
  const CloneSelect = cloneElement(children, { placeholder: placeholder || `เลือก${label}`, disabled });

  return (
    <Form.Item name={name} label={label} tooltip={tooltip} rules={[{ required, message: `กรุณาเลือก${label}` }]}>
      {CloneSelect}
    </Form.Item>
  );
}
